import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Upload } from "lucide-react";

function DefaultActions({ studyId }) {
  return (
    <>
      {studyId && (
        <Link to={`/studies/${studyId}`} className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white text-[#12305e] text-sm font-bold hover:bg-blue-50 transition-colors" data-testid="banner-view-study">
          Ver análisis completo <ArrowRight size={15} />
        </Link>
      )}
      <Link to="/subidas/abcd" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full border border-white/40 text-sm font-semibold hover:bg-white/10 transition-colors" data-testid="banner-upload">
        <Upload size={15} /> Subir datos
      </Link>
    </>
  );
}

export function BannerFarmanaliza({ pharmacy, studyId, image = "/img/farmanaliza-banner.jpg?v=2", kicker = "Bienvenido a",
  subtitle = "Gestión de stocks en farmacia", text, testid = "farmanaliza-banner", compact = false }) {
  return (
    <div className={"card overflow-hidden mb-8 grid grid-cols-1 fade-in " + (compact ? "md:grid-cols-[minmax(0,340px)_1fr]" : "lg:grid-cols-[minmax(0,560px)_1fr]")} data-testid={testid}>
      <img src={image} alt={`Farmanaliza · ${subtitle}`} className="w-full h-full object-cover aspect-[3/2]" data-testid={`${testid}-img`} />
      <div className={"flex flex-col justify-center bg-[#12305e] text-white relative overflow-hidden " + (compact ? "p-6 lg:p-8" : "p-8 lg:p-10")}>
        <div className="absolute top-0 right-0 h-full w-24 bg-[#1f6fd1]/20 -skew-x-12 origin-top-right pointer-events-none" />
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">{kicker}</div>
        <h1 className="mt-3">
          <img src="/img/farmanaliza-logo-blanco.png?v=3" alt="Farmanaliza" className={compact ? "h-14 sm:h-16 w-auto" : "h-16 sm:h-20 w-auto"} data-testid={`${testid}-logo`} />
        </h1>
        <p className="text-base md:text-lg text-blue-100 mt-2">{subtitle}</p>
        {text && <p className="text-sm text-blue-200 mt-3 max-w-lg">{text}</p>}
        {pharmacy && <p className="text-sm text-blue-200 mt-4" data-testid={`${testid}-pharmacy`}>{pharmacy}</p>}
        {!compact && <div className="flex flex-wrap gap-3 mt-6"><DefaultActions studyId={studyId} /></div>}
        <div className={"text-[10px] uppercase tracking-[0.25em] text-blue-300 " + (compact ? "mt-4" : "mt-8")}>Archiduque Consulting</div>
      </div>
    </div>
  );
}
